import type { SurveyConfigWithType } from '../dtos/survey.dto'
import { SurveyType } from '../dtos/survey.dto'

/**
 * Returns the persisted survey config for a type from `GET v1/volunteering/opportunities/:id/survey`
 * (`surveys` list). Matches how the API groups post_event and pre_event.
 */
export function findOpportunitySurvey(
  data: { surveys?: SurveyConfigWithType[] } | null | undefined,
  surveyType: SurveyType
): SurveyConfigWithType | undefined {
  return data?.surveys?.find((s) => s.surveyType === surveyType)
}
